import React, { useContext, useEffect } from "react";
import { Switch, Route, useLocation } from "wouter";
import classnames from "classnames";
import useAxios from "axios-hooks";

import { ContextProvider } from "../../components/src/contexts/ContextProvider";
import { REACT_APP_NAME, REACT_APP_DB_NAME, REACT_APP_AUTH_URI } from "./env";

import { JournalEntriesForm } from "./containers/accounting/JournalEntriesForm";
import { AddValuationPage } from "./containers/AddValuationPage";
import { AumPage } from "./containers/AumPage";
import { Aum2Page } from "./containers/Aum2Page";
import { AumQuarterlyPage } from "./containers/AumQuarterlyPage";
import { ReconcileBrokerTransactionsPage } from "./containers/ReconcileBrokerTransactionsPage";
import { BrokerConfirmationsCompletePage } from "./containers/BrokerConfirmationsPage";
import { ChangePasswordPage } from "./containers/ChangePasswordPage";
import { CollateralPage } from "./containers/collateral/CollateralPage";
import { CorporateActionsReconciliationPage } from "./containers/CorporateActionsReconciliationPage";
import { CorporateActionsPage } from "./containers/CorporateActionsPage";
import { SwiftCorporateActionPage } from "./containers/SwiftCorporateActionPage";
import { DealBlotterPage } from "./containers/DealBlotterPage";
import { FundParsePage } from "./containers/fundparse/FundParsePage";
import { InstrumentPage } from "./containers/InstrumentPage";
import { InstrumentsPage } from "./containers/InstrumentsPage";
import { ZeroCouponLinearInstrumentPage } from "./containers/ZeroCouponLinearInstrumentPage";
import { SwaptionInstrumentPage } from "./containers/SwaptionInstrumentPage";
import { LimitReportPage } from "./containers/LimitReportPage";
import { PartiesPage } from "./containers/PartiesPage";
import { PortfolioManagerPage } from "./containers/pm/PortfolioManagerPage";
import { PositionCashBalancePage } from "./containers/PositionCashBalancePage";
import { PositionFundUnitsPage } from "./containers/PositionFundUnitsPage";
import { ReconciliationPage } from "./containers/ReconciliationPage";
import { PositionReconciliationPage } from "./containers/PositionReconciliationPage";
import { ReportPage } from "./containers/ReportPage";
import { ReportsPage } from "./containers/ReportsPage";
import { SlashPage } from "./containers/SlashPage";
import { StatsPage } from "./containers/StatsPage";
import { InstrumentPositionsPage } from "./containers/InstrumentPositionsPage";
import { TAccountChartPage } from "./containers/accounting/TAccountChartPage";
import { TimeSeriesPage } from "./containers/timeseries/TimeSeriesPage";
import { TokenPage } from "./containers/TokenPage";
import { TransactionPage } from "./containers/TransactionPage";
import { VersionsPage } from "./containers/VersionsPage";
import { TransactionsPage } from "./containers/TransactionsPage";
import { TransferAgentOrdersPage } from "./containers/TransferAgentOrdersPage";
import { ValuationPage } from "./containers/ValuationPage";
import { ValuationsPage } from "./containers/ValuationsPage";
import { AdminUsersPage } from "./containers/admin/AdminUsersPage";
import { AdminUserPage } from "./containers/admin/AdminUserPage";
import { AdminRolesPage } from "./containers/admin/AdminRolesPage";
import { AdminRolePage } from "./containers/admin/AdminRolePage";
import { CalculateNavPage } from "./containers/nav-v2/CalculateNavPage";
import { FoNavPage } from "./containers/fonav/FoNavPage";
import { NavPage as Nav2Page } from "./containers/nav-v2/NavPage";
import { NavsPage } from "./containers/nav-v2/NavsPage";
import { ScreensPage } from "./containers/ScreensPage";
import { ScreenPage } from "./containers/ScreenPage";
import { EsgPage } from "./containers/EsgPage";
import { IssuerProgramsPage } from "./containers/IssuerProgramsPage";
import { IssuerProgramPage } from "./containers/IssuerProgramPage";
import { PartyPage } from "./containers/party/PartyPage";
import { PdfViewPage } from "./containers/PdfViewPage";
import { PdfViewPages } from "./containers/PdfViewPages";
import { TransferAgentOrdersSummaryPage } from "./containers/TransferAgentOrdersSummaryPage";
import { TimeSeriesEditorPage } from "./containers/timeseries/TimeSeriesEditorPage";
import { MiniTransactionPage } from "./containers/MiniTransactionPage";
import { TicketsPage } from "./containers/TicketsPage";
import { TicketPage } from "./containers/TicketPage";
import { StatementsReportingPage } from "./containers/accounting/statementsreporting/StatementsReportingPage";
import { IncomeStatementPage } from "./containers/accounting/IncomeStatementPage";
import { SwapLab2Page } from "./containers/swaplab2/SwapLab2Page";
import { ValuationMappingsPage } from "./containers/ValuationMappingsPage";
import { ValuationMappingPage } from "./containers/ValuationMappingPage";
import { PerformancePage } from "./containers/performance/PerformancePage";
import { AccountPerformancePage } from "./containers/accountPerformance/AccountPerformancePage";
import { PortfolioRiskAndLimits } from "./containers/start/PortfolioRiskAndLimits";
import { OperationsTabPage } from "./containers/start/OperationsTabPage";
import { ClientPage } from "./containers/ClientPage";
import { ComparePage } from "./containers/ComparePage";
import { ComparePage2 } from "./containers/ComparePage2";
import { MoversPage } from "./containers/MoversPage";
import { PositionsGroupedPage } from "./containers/PositionsGroupedPage";
import { SwaptionsPage } from "./containers/SwaptionsPage";
import { BondsPage } from "./containers/BondsPage";
import { BankAccountTransactionsPage } from "./containers/BankAccountTransactionsPage";
import { BankAccountTransactionPage } from "./containers/BankAccountTransactionPage";
import { BrokerTransactionsPage } from "./containers/BrokerTransactionsPage";
import { BrokerTransactionPage } from "./containers/BrokerTransactionPage";
import { CalendarsPage } from "./containers/CalendarsPage";
import { CalendarPage } from "./containers/CalendarPage";
import { CurveDefinitionPage } from "./containers/CurveDefinitionPage";
import { CurveDefinitionsPage } from "./containers/CurveDefinitionsPage";
import { AgreementsPage } from "./containers/AgreementsPage";
import { AgreementPage } from "./containers/AgreementPage";
import { ValuationComparePage } from "./containers/swaplab2/ValuationComparePage";
import { NotesPage } from "./containers/note/NotesPage";
import { NotePage } from "./containers/note/NotePage";
import { EsgNotePage } from "./containers/note/EsgNotePage";
import { DurationRiskDocPage } from "./containers/swaplab2/DurationRiskDocPage";
import { TermsOfServicePage } from "./containers/TermsOfServicePage";
import { TransactionItemsPage } from "./containers/TransactionItemsPage";
import { CustodianPositionsPage } from "./containers/CustodianPositionsPage";
import { CustodianPositionPage } from "./containers/CustodianPositionPage";
import { TestPage } from "./containers/TestPage";
import { Iorp2Page } from "./containers/Iorp2Page";
import { ShareRegisterPage } from "./containers/ShareRegisterPage";
import { QuotesPage } from "./containers/QuotesPage";
import { QuotePage } from "./containers/QuotePage";
import { PricesPage } from "./containers/PricesPage";
import { PricePage } from "./containers/PricePage";
import { BankAccountReconciliationPage } from "./containers/BankAccountsReconciliationPage";
import { SwedishFinancialAuthoritiesPage } from "./containers/reporting/SwedishFinancialAuthoritiesPage";
import { SwedishFiClassificationPage } from "./containers/reporting/SwedishFiClassificationPage";
import { AnnualReportPage } from "./containers/reporting/AnnualReportPage";
import { AnnualReportsPage } from "./containers/reporting/AnnualReportsPage";
import { SideNav } from "./containers/SideNav";
import { Nav } from "./components/Nav";
import { CustomersPage } from "./containers/customer/CustomersPage";
import { DownloadFile } from "./components/form/DownloadFile";
import { EdgeAlert } from "../../components/src/form/EdgeAlert";
import { JobRunPage } from "./containers/scheduler/JobRunPage";
import { JobsPage } from "./containers/scheduler/JobsPage";
import { JobPage as Job2Page } from "./containers/scheduler/JobPage";
import { CostPage } from "./containers/backoffice/CostPage";
import { TotalUnitPage } from "./containers/backoffice/TotalUnitPage";
import { CostsPage } from "./containers/backoffice/CostsPage";
import { MonthlyCostsPage } from "./containers/backoffice/MonthlyCostsPage";
import { SwapConstituentsPage } from "./containers/SwapConstituentsPage";
import { RegisterExtractsPage } from "./containers/RegisterExtractsPage";
import { RegisterExtractPage } from "./containers/RegisterExtractPage";
import { PortfolioManagerAccounting } from "./containers/accounting/PortfolioManagerAccounting";
import { ExtensionsPage } from "./containers/ExtensionsPage";
import { ExtensionPage } from "./containers/ExtensionPage";
import { TAccountChartsPage } from "./containers/accounting/TAccountingChartsPage";
import { TAccountChartsPage as TAccountCharts2Page } from "./containers/accounting2/TAccountChartsPage";
import { TAccountChartPage as TAccountChart2Page } from "./containers/accounting2/TAccountChartPage";
import { AccountingRunsPage as AccountingRuns2Page } from "./containers/accounting2/AccountingRunsPage";
import { AccountingRunPage as AccountingRun2Page } from "./containers/accounting2/AccountingRunPage";
import { AccountingStatementsPage as AccountingStatements2Page } from "./containers/accounting2/AccountingStatementsPage";
import { AccountingReconciliationPage as AccountingReconciliation2Page } from "./containers/accounting2/AccountingReconciliationPage";
import { AccountingLogicPage as AccountingLogic2Page } from "./containers/accounting2/AccountingLogicPage";
import { TAccountChartLogicPage as TAccountChartLogic2Page } from "./containers/accounting2/TAccountChartLogicPage";
import { ClientContext } from "../../components/src/contexts/ClientContext";
import { OpenPaymentsConsentsPage } from "./containers/backoffice/OpenPayments/OpenPaymentsConsentsPage";
import { OPItemContextProvider } from "./contexts/OpItemContextProvider";
import { useInactivityLogout } from "../../components/src/common/UseInactivityLogout";
import { PaymentsPage } from "./containers/backoffice/OpenPayments/OpenPaymentsPaymentsPage";
import { OpenPaymentsConsentPage } from "./containers/backoffice/OpenPayments/OpenPaymentsConsentPage";
import { AdminRedisPage } from "./containers/admin/AdminRedisPage";
import { LimitTrialPage } from "./containers/LimitTrialPage";

import { loginContext, getDefaultLoginValue } from "./containers/Login";
import { SideNavProvider } from "../../components/src/contexts/SideNavContext";

function capitalizeFirstLetter(s: string): string {
    if (s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    } else {
        return "";
    }
}

const NoMatch = () => {
    const [location] = useLocation();
    return (
        <div>
            <h3>
                No match for <code>{location}</code>
            </h3>
        </div>
    );
};

interface ProtectedLayoutProps {
    children: React.ReactNode;
}

const ProtectedLayout = ({ children }: ProtectedLayoutProps): React.ReactElement => {
    return (
        <SideNavProvider>
            <div>
                <SideNav />
                <header>
                    <EdgeAlert />
                    <Nav
                        title={
                            capitalizeFirstLetter(REACT_APP_NAME) +
                            (REACT_APP_DB_NAME === "prod" ? "" : " " + REACT_APP_DB_NAME) +
                            " Portal"
                        }
                        prod={REACT_APP_DB_NAME === "prod"}
                    />
                </header>
                {children}
            </div>
        </SideNavProvider>
    );
};

interface ILayoutProps {
    fullWidth?: boolean;
    fullHeight?: boolean;
    children?: React.ReactElement;
    title?: string;
    showClient?: boolean;
}
const Layout = ({
    children,
    fullWidth = false,
    fullHeight = false,
    title = "Captor",
    showClient = false
}: ILayoutProps): React.ReactElement => {
    const { client } = useContext(ClientContext);

    useEffect(() => {
        document.title = showClient && client && client._id != "000000000000000000000000" ? `${title} - ${client.name}` : title;
    }, [client, client.dashName, title, showClient]);
    return (
        <div
            className={classnames({
                "w-full px-4 mx-auto": fullWidth,
                "px-4": !fullWidth,
                "h-full": fullHeight
            })}
        >
            {children}
        </div>
    );
};

export const App = (): React.ReactElement => {
    const { setLogin } = useContext(loginContext);
    const [__, request] = useAxios({ withCredentials: true }, { manual: true });
    const handleLogout = async () => {
        const _response = await request({
            method: "DELETE",
            url: REACT_APP_AUTH_URI + "/set",
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json"
            }
        })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                console.log("User has been logged out due to inactivity");
                setLogin(getDefaultLoginValue());
            });
    };

    useInactivityLogout(handleLogout, 30 * 60); // 30 minutes

    return (
        <ContextProvider>
            <OPItemContextProvider>
                <div className="app">
                    <ProtectedLayout>
                        <Switch>
                            <Route path="/">
                                <SlashPage />
                            </Route>
                            <Route path="/client">
                                <Layout fullWidth>
                                    <ClientPage />
                                </Layout>
                            </Route>
                            <Route path="/client/:clientDashName">
                                <Layout fullWidth title="Client" showClient>
                                    <ClientPage />
                                </Layout>
                            </Route>
                            <Route path="/aum">
                                <Layout fullWidth fullHeight title="AUM">
                                    <AumPage />
                                </Layout>
                            </Route>
                            <Route path="/aum2">
                                <Layout fullWidth fullHeight title="AUM 2">
                                    <Aum2Page />
                                </Layout>
                            </Route>
                            <Route path="/aum-quarterly">
                                <Layout fullWidth title="AUM Quarterly">
                                    <AumQuarterlyPage />
                                </Layout>
                            </Route>
                            <Route path="/fo-nav-beta">
                                <Layout fullWidth title="FO NAV">
                                    <FoNavPage />
                                </Layout>
                            </Route>
                            <Route path="/fo-nav-beta/:fundId">
                                <Layout fullWidth title="FO NAV">
                                    <FoNavPage />
                                </Layout>
                            </Route>
                            <Route path="/calculatenav">
                                <Layout fullWidth title="NAV">
                                    <CalculateNavPage />
                                </Layout>
                            </Route>
                            <Route path="/calculatenav/:fundDashName">
                                <Layout fullWidth title="NAV">
                                    <CalculateNavPage />
                                </Layout>
                            </Route>
                            <Route path="/navs">
                                <Layout fullWidth title="NAV">
                                    <NavsPage />
                                </Layout>
                            </Route>
                            <Route path="/nav2/:id">
                                <Layout fullWidth title="NAV">
                                    <Nav2Page />
                                </Layout>
                            </Route>
                            <Route path="/parties/:id">
                                <Layout fullWidth title="Party">
                                    <PartyPage />
                                </Layout>
                            </Route>
                            <Route path="/parties/:id/:tabId">
                                <Layout fullWidth title="Party">
                                    <PartyPage />
                                </Layout>
                            </Route>
                            <Route path="/parties/:id/:tabId/:itemId">
                                <Layout fullWidth title="Party">
                                    <PartyPage />
                                </Layout>
                            </Route>
                            <Route path="/parties">
                                <Layout fullWidth title="Parties">
                                    <PartiesPage />
                                </Layout>
                            </Route>
                            <Route path="/screens">
                                <Layout fullWidth title="Screens">
                                    <ScreensPage />
                                </Layout>
                            </Route>
                            <Route path="/screens/:id">
                                <Layout fullWidth={false} title="Screen">
                                    <ScreenPage />
                                </Layout>
                            </Route>
                            <Route path="/shareregister">
                                <Layout fullWidth title="Share register">
                                    <ShareRegisterPage />
                                </Layout>
                            </Route>
                            <Route path="/shareregister/:tabId">
                                <Layout fullWidth title="Share register">
                                    <ShareRegisterPage />
                                </Layout>
                            </Route>
                            <Route path="/esg">
                                <Layout title="ESG">
                                    <EsgPage />
                                </Layout>
                            </Route>
                            <Route path="/esg/:clientDashName">
                                <Layout title="ESG" showClient>
                                    <EsgPage />
                                </Layout>
                            </Route>
                            <Route path="/esgnotes">
                                <Layout title="New ESG Note">
                                    <NotesPage esgOnly={true} routeToNew={"/esgnotes/new"} routeToNewText={"New ESG note"} />
                                </Layout>
                            </Route>
                            <Route path="/esgnotes/:id">
                                <Layout fullWidth={true} fullHeight={true} title="Notes ESG">
                                    <EsgNotePage routeToNotes={"/esgnotes"} routeToNotesText={"All ESG notes"}></EsgNotePage>
                                </Layout>
                            </Route>
                            <Route path="/issuerprograms">
                                <Layout fullWidth title="Issuerprograms">
                                    <IssuerProgramsPage />
                                </Layout>
                            </Route>
                            <Route path="/issuerprograms/:id">
                                <Layout fullWidth={false} title="Issuerprograms">
                                    <IssuerProgramPage />
                                </Layout>
                            </Route>
                            <Route path="/openpayments/consents">
                                <Layout fullWidth={false} title="Consents">
                                    <OpenPaymentsConsentsPage />
                                </Layout>
                            </Route>
                            <Route path="/openpayments/consents/:id">
                                <Layout fullWidth={false} title="Consent">
                                    <OpenPaymentsConsentPage />
                                </Layout>
                            </Route>
                            <Route path="/openpayments/payments">
                                <Layout fullWidth={true} title="Payments">
                                    <PaymentsPage />
                                </Layout>
                            </Route>
                            <Route path="/openpayments/payments/:id">
                                <Layout fullWidth={true} title="Payment">
                                    <PaymentsPage />
                                </Layout>
                            </Route>
                            <Route path="/reconciliation">
                                <Layout fullWidth={false} title="Units Reconciliation">
                                    <ReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/reconciliation/custodianpositions">
                                <Layout fullWidth title="Custodian Positions">
                                    <CustodianPositionsPage />
                                </Layout>
                            </Route>
                            <Route path="/reconciliation/custodianpositions/:id">
                                <Layout fullWidth={false} title="Custodian Position">
                                    <CustodianPositionPage />
                                </Layout>
                            </Route>
                            <Route path="/positionreconciliation">
                                <Layout fullWidth title="Position Reconciliation">
                                    <PositionReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/brokertransactions/:type/:id">
                                <Layout fullWidth title="Broker Transaction">
                                    <ReconcileBrokerTransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/brokertransactions">
                                <Layout fullWidth title="Broker Transactions">
                                    <ReconcileBrokerTransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/brokerconfirmations">
                                <Layout fullWidth title="Broker Confirmations">
                                    <BrokerConfirmationsCompletePage />
                                </Layout>
                            </Route>
                            <Route path="/brokerconfirmations/:type/:id">
                                <Layout fullWidth title="Broker Confirmation">
                                    <BrokerConfirmationsCompletePage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/corporateactions/:type/:id">
                                <Layout fullWidth title="Corporate Actions">
                                    <CorporateActionsReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/corporateactions">
                                <Layout fullWidth title="Corporate Actions">
                                    <CorporateActionsReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/swiftcorporateaction/:id">
                                <Layout fullWidth={false} title="Swift Corporate Action">
                                    <SwiftCorporateActionPage />
                                </Layout>
                            </Route>
                            <Route path="/corporateactions">
                                <Layout fullWidth title="Corporate Actions">
                                    <CorporateActionsPage />
                                </Layout>
                            </Route>
                            <Route path="/corporateactions/:type/:id">
                                <Layout fullWidth title="Corporate Actions">
                                    <CorporateActionsPage />
                                </Layout>
                            </Route>
                            <Route path="/transferagentorders/summary">
                                <Layout fullWidth title="Order Summary">
                                    <TransferAgentOrdersSummaryPage />
                                </Layout>
                            </Route>
                            <Route path="/transferagentorders">
                                <Layout fullWidth title="TransferAgent Orders">
                                    <TransferAgentOrdersPage />
                                </Layout>
                            </Route>
                            <Route path="/transferagentorders/:id">
                                <Layout fullWidth title="TransferAgent Order">
                                    <TransferAgentOrdersPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/cashbalance">
                                <Layout fullWidth title="Cash Balance">
                                    <PositionCashBalancePage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/cashbalance/:clientDashName/:id">
                                <Layout fullWidth title="Cash Balance" showClient>
                                    <PositionCashBalancePage />
                                </Layout>
                            </Route>
                            <Route path="/reporting/annualreports">
                                <Layout fullWidth title="Annual/semiannual Reporting">
                                    <AnnualReportsPage />
                                </Layout>
                            </Route>
                            <Route path="/reporting/annualreports/:id">
                                <Layout fullWidth title="Annual/semiannual Report">
                                    <AnnualReportPage />
                                </Layout>
                            </Route>
                            <Route path="/backoffice/costs">
                                <Layout fullWidth title="Costs">
                                    <CostsPage />
                                </Layout>
                            </Route>
                            <Route path="/backoffice/costs/:id">
                                <Layout title="Costs">
                                    <CostPage />
                                </Layout>
                            </Route>
                            <Route path="/backoffice/totalunits/:id">
                                <Layout title="Total units">
                                    <TotalUnitPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/bankaccounts/:clientDashName">
                                <Layout fullWidth title="Bank Accounts Reconciliation" showClient>
                                    <BankAccountReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/bankaccounts">
                                <Layout fullWidth title="Bank Accounts Reconciliation">
                                    <BankAccountReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/bankaccounts/:clientDashName/:id">
                                <Layout fullWidth title="Bank Accounts Reconciliation" showClient>
                                    <BankAccountReconciliationPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/cashbalance/:clientDashName">
                                <Layout fullWidth title="Cash Balance" showClient>
                                    <PositionCashBalancePage />
                                </Layout>
                            </Route>
                            <Route path="/bankaccounttransactions">
                                <Layout fullWidth={false} title="Bank Accounts Transactions">
                                    <BankAccountTransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/bankaccounttransactions/:id">
                                <Layout fullWidth={false} title="Bank Account Transaction">
                                    <BankAccountTransactionPage />
                                </Layout>
                            </Route>
                            <Route path="/brokertransactions">
                                <Layout fullWidth={false} title="Broker Transactions">
                                    <BrokerTransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/brokertransactions/:id">
                                <Layout fullWidth={false} title="Broker Transaction">
                                    <BrokerTransactionPage />
                                </Layout>
                            </Route>
                            <Route path="/calendars">
                                <Layout fullWidth title="Calendars">
                                    <CalendarsPage />
                                </Layout>
                            </Route>
                            <Route path="/calendars/:id">
                                <Layout fullWidth title="Calendar">
                                    <CalendarPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/collateral">
                                <Layout fullWidth title="Collateral Management">
                                    <CollateralPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/collateral/:clientDashName">
                                <Layout fullWidth title="Collateral Management" showClient>
                                    <CollateralPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/collateral/:clientDashName/:id">
                                <Layout fullWidth title="Collateral Management" showClient>
                                    <CollateralPage />
                                </Layout>
                            </Route>
                            <Route path="/reconcile/fundunits">
                                <Layout fullWidth={false} title="Fund Units">
                                    <PositionFundUnitsPage />
                                </Layout>
                            </Route>
                            <Route path="/token">
                                <Layout fullWidth={false}>
                                    <TokenPage />
                                </Layout>
                            </Route>
                            <Route path="/transaction/:id">
                                <Layout fullWidth={false} title="Transaction">
                                    <TransactionPage />
                                </Layout>
                            </Route>
                            <Route path="/versions">
                                <Layout fullWidth={true} title="Versions">
                                    <VersionsPage />
                                </Layout>
                            </Route>
                            <Route path="/versions/:type">
                                <Layout fullWidth={true} title="Versions">
                                    <VersionsPage />
                                </Layout>
                            </Route>
                            <Route path="/versions/:type/:id">
                                <Layout fullWidth={false} title="Version">
                                    <VersionsPage />
                                </Layout>
                            </Route>
                            <Route path="/valuation/add">
                                <Layout fullWidth={false} title="Add Valuation">
                                    <AddValuationPage />
                                </Layout>
                            </Route>
                            <Route path="/swapconstituents/:instrumentId">
                                <Layout fullWidth={false}>
                                    <SwapConstituentsPage />
                                </Layout>
                            </Route>
                            <Route path="/instruments/new/ZeroCouponLinear">
                                <Layout fullWidth={false} title="New Zero Coupon Linear Instrument">
                                    <ZeroCouponLinearInstrumentPage />
                                </Layout>
                            </Route>
                            <Route path="/instruments/new/Swaption">
                                <Layout fullWidth={false} title="New Swaption Instrument">
                                    <SwaptionInstrumentPage />
                                </Layout>
                            </Route>
                            <Route path="/instruments/:id">
                                <Layout fullWidth={false} title="Instrument">
                                    <InstrumentPage />
                                </Layout>
                            </Route>
                            <Route path="/instruments">
                                <Layout fullWidth title="Instruments">
                                    <InstrumentsPage />
                                </Layout>
                            </Route>
                            <Route path="/tickets/:id">
                                <Layout fullWidth={false} title="Ticket">
                                    <TicketPage />
                                </Layout>
                            </Route>
                            <Route path="/tickets">
                                <Layout fullWidth={false} title="Tickets">
                                    <TicketsPage />
                                </Layout>
                            </Route>
                            {/* Hidden route (not in SideNav): ExtTptFileConsolidator job UI at /fundparse */}
                            <Route path="/fundparse/:clientId/:date">
                                <Layout fullWidth={false} title="Fund Parse">
                                    <FundParsePage />
                                </Layout>
                            </Route>
                            <Route path="/fundparse/:clientId">
                                <Layout fullWidth={false} title="Fund Parse">
                                    <FundParsePage />
                                </Layout>
                            </Route>
                            <Route path="/fundparse">
                                <Layout fullWidth={false} title="Fund Parse">
                                    <FundParsePage />
                                </Layout>
                            </Route>
                            <Route path="/jobs">
                                <Layout fullWidth={false} title="Jobs">
                                    <JobsPage />
                                </Layout>
                            </Route>
                            <Route path="/jobs/:id">
                                <Layout fullWidth={false} title="Job">
                                    <Job2Page />
                                </Layout>
                            </Route>
                            <Route path="/jobruns/:id">
                                <Layout>
                                    <JobRunPage />
                                </Layout>
                            </Route>
                            <Route path="/journalentries/:id">
                                <Layout fullWidth title="Journal Entries">
                                    <JournalEntriesForm />
                                </Layout>
                            </Route>
                            <Route path="/journalentries/:clientId/:accountingPeriod">
                                <Layout fullWidth title="Journal Entries">
                                    <JournalEntriesForm />
                                </Layout>
                            </Route>
                            <Route path="/journalentries/:clientId/:accountingPeriod/:maxNumber">
                                <Layout fullWidth title="Journal Entries">
                                    <JournalEntriesForm />
                                </Layout>
                            </Route>
                            <Route path="/attachment/pdf/:id">
                                <Layout fullWidth title="Attachment">
                                    <PdfViewPage />
                                </Layout>
                            </Route>
                            <Route path="/attachment/pdf/:id/pages">
                                <Layout fullWidth title="Attachment">
                                    <PdfViewPages />
                                </Layout>
                            </Route>
                            <Route path="/journalentries/:clientId/:accountingPeriod/:maxNumber/:type">
                                <Layout fullWidth title="Journal Entries">
                                    <JournalEntriesForm />
                                </Layout>
                            </Route>
                            <Route path="/journalentries/:clientId/:accountingPeriod/:maxNumber/:type/:journalEntryId">
                                <Layout fullWidth title="Journal Entries">
                                    <JournalEntriesForm />
                                </Layout>
                            </Route>
                            <Route path="/limitreportv3">
                                <Layout fullWidth={false} title="Limit Reports">
                                    <LimitReportPage />
                                </Layout>
                            </Route>
                            <Route path="/limitreportv3/:clientDashName">
                                <Layout fullWidth={false} title="Limit Reports" showClient>
                                    <LimitReportPage />
                                </Layout>
                            </Route>
                            <Route path="/limittrial">
                                <Layout fullWidth={false} title="Limit Trial">
                                    <LimitTrialPage />
                                </Layout>
                            </Route>
                            <Route path="/reporting/quarterly">
                                <Layout fullWidth={false} title="Quarterly Reporting">
                                    <SwedishFinancialAuthoritiesPage />
                                </Layout>
                            </Route>
                            <Route path="/reporting/quarterly/:clientDashName">
                                <Layout fullWidth={false} title="Quarterly Reporting" showClient>
                                    <SwedishFinancialAuthoritiesPage />
                                </Layout>
                            </Route>
                            <Route path="/reporting/classification">
                                <Layout fullWidth={false} title="Bond Classification">
                                    <SwedishFiClassificationPage />
                                </Layout>
                            </Route>
                            <Route path="/report/:id">
                                <Layout fullWidth title="Report">
                                    <ReportPage />
                                </Layout>
                            </Route>
                            <Route path="/reports">
                                <Layout fullWidth title="Reports">
                                    <ReportsPage />
                                </Layout>
                            </Route>
                            <Route path="/stats">
                                <Layout fullWidth={false}>
                                    <StatsPage />
                                </Layout>
                            </Route>
                            <Route path="/testtaccountchart">
                                <Layout fullWidth={false}>
                                    <TAccountChartsPage />
                                </Layout>
                            </Route>
                            <Route path="/taccountcharts/:id/:tAccountIndex/:tAccountMappingIndex">
                                <Layout fullWidth title="T-account Charts">
                                    <TAccountChartPage />
                                </Layout>
                            </Route>
                            <Route path="/taccountcharts/:id">
                                <Layout fullWidth title="T-account Charts">
                                    <TAccountChartPage />
                                </Layout>
                            </Route>
                            <Route path="/taccountcharts">
                                <Layout fullWidth title="T-account Charts">
                                    <TAccountChartsPage />
                                </Layout>
                            </Route>
                            <Route path="/taccountcharts2/:id">
                                <Layout fullWidth title="T-account Chart 2">
                                    <TAccountChart2Page />
                                </Layout>
                            </Route>
                            <Route path="/taccountcharts2">
                                <Layout fullWidth title="T-account Charts 2">
                                    <TAccountCharts2Page />
                                </Layout>
                            </Route>
                            <Route path="/taccountchartlogic2">
                                <Layout fullWidth={false} title="T-account Chart Logic 2">
                                    <TAccountChartLogic2Page />
                                </Layout>
                            </Route>
                            <Route path="/accountinglogic2">
                                <Layout fullWidth={false} title="Accounting Logic 2">
                                    <AccountingLogic2Page />
                                </Layout>
                            </Route>
                            <Route path="/accountingruns2/:clientId/:id/reconciliation">
                                <Layout fullWidth title="Accounting Reconciliation 2">
                                    <AccountingReconciliation2Page />
                                </Layout>
                            </Route>
                            <Route path="/accountingruns2/:clientId/:id/statements">
                                <Layout fullWidth title="Accounting Statements 2">
                                    <AccountingStatements2Page />
                                </Layout>
                            </Route>
                            <Route path="/accountingruns2/:clientId/:id">
                                <Layout fullWidth title="Accounting Run 2">
                                    <AccountingRun2Page />
                                </Layout>
                            </Route>
                            <Route path="/accountingruns2/:clientId?">
                                <Layout fullWidth title="Accounting Runs 2">
                                    <AccountingRuns2Page />
                                </Layout>
                            </Route>
                            <Route path="/test">
                                <Layout fullWidth={false}>
                                    <TestPage />
                                </Layout>
                            </Route>
                            <Route path="/iorp2">
                                <Layout fullWidth={false}>
                                    <Iorp2Page />
                                </Layout>
                            </Route>
                            <Route path="/iorp2/:clientDashName">
                                <Layout fullWidth title="iorp2" showClient>
                                    <Iorp2Page />
                                </Layout>
                            </Route>
                            <Route path="/instrumentpositions">
                                <Layout fullWidth={false}>
                                    <InstrumentPositionsPage />
                                </Layout>
                            </Route>
                            <Route path="/financialstatements">
                                <Layout fullWidth title="Financial Statements">
                                    <StatementsReportingPage />
                                </Layout>
                            </Route>
                            <Route path="/financialstatements/:tab">
                                <Layout fullWidth title="Financial Statements">
                                    <StatementsReportingPage />
                                </Layout>
                            </Route>
                            <Route path="/financialstatements/:tab/:portfolioTransactionId">
                                <Layout fullWidth title="Financial Statements">
                                    <StatementsReportingPage />
                                </Layout>
                            </Route>
                            <Route path="/incomestatement">
                                <Layout fullWidth title="Income Statement">
                                    <IncomeStatementPage />
                                </Layout>
                            </Route>
                            <Route path="/accountingpm/:id/:endDate/:export">
                                <Layout fullWidth title="Accounting">
                                    <PortfolioManagerAccounting />
                                </Layout>
                            </Route>
                            <Route path="/accountingpm/:id/:endDate">
                                <Layout fullWidth title="Accounting">
                                    <PortfolioManagerAccounting />
                                </Layout>
                            </Route>
                            <Route path="/accountingpm/:id">
                                <Layout fullWidth title="Accounting">
                                    <PortfolioManagerAccounting />
                                </Layout>
                            </Route>
                            <Route path="/accountingpm">
                                <Layout fullWidth title="Accounting">
                                    <PortfolioManagerAccounting />
                                </Layout>
                            </Route>
                            <Route path="/timeseries/:id">
                                <Layout fullWidth={false} title="Timeseries">
                                    <TimeSeriesEditorPage />
                                </Layout>
                            </Route>
                            <Route path="/timeseries">
                                <Layout fullWidth title="Timeseries">
                                    <TimeSeriesPage />
                                </Layout>
                            </Route>
                            <Route path="/transactions/:id">
                                <Layout fullWidth title="Transaction">
                                    <TransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/transactions/:type/:id">
                                <Layout fullWidth title="Transaction">
                                    <TransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/transactions">
                                <Layout fullWidth title="Transactions">
                                    <TransactionsPage />
                                </Layout>
                            </Route>
                            <Route path="/transactionitems/:id">
                                <Layout fullWidth title="Transaction Items">
                                    <TransactionItemsPage />
                                </Layout>
                            </Route>
                            <Route path="/registerextracts">
                                <Layout fullWidth title="TA Register Extracts">
                                    <RegisterExtractsPage />
                                </Layout>
                            </Route>
                            <Route path="/registerextracts/:id">
                                <Layout fullWidth title="TA Register Extracts">
                                    <RegisterExtractPage />
                                </Layout>
                            </Route>
                            <Route path="/transactionitems">
                                <Layout fullWidth title="Transaction Items">
                                    <TransactionItemsPage />
                                </Layout>
                            </Route>
                            <Route path="/dealblotter/:id">
                                <Layout fullWidth title="Deal Blotter">
                                    <DealBlotterPage />
                                </Layout>
                            </Route>
                            <Route path="/dealblotter">
                                <Layout fullWidth title="Deal Blotter">
                                    <DealBlotterPage />
                                </Layout>
                            </Route>
                            <Route path="/minitransactions/:id">
                                <Layout fullWidth={false}>
                                    <MiniTransactionPage />
                                </Layout>
                            </Route>
                            <Route path="/minitransactions">
                                <Layout fullWidth={false}>
                                    <MiniTransactionPage />
                                </Layout>
                            </Route>
                            <Route path="/pm/:id/:tab/:type/:transactionId">
                                <Layout fullWidth>
                                    <PortfolioManagerPage />
                                </Layout>
                            </Route>
                            <Route path="/pm/:id/:tab">
                                <Layout fullWidth>
                                    <PortfolioManagerPage />
                                </Layout>
                            </Route>
                            <Route path="/pm/:id">
                                <Layout fullWidth>
                                    <PortfolioManagerPage />
                                </Layout>
                            </Route>
                            <Route path="/pm">
                                <Layout fullWidth>
                                    <PortfolioManagerPage />
                                </Layout>
                            </Route>
                            <Route path="/valuation/:id">
                                <Layout fullWidth={false} title="Valuations">
                                    <ValuationPage />
                                </Layout>
                            </Route>
                            <Route path="/valuations">
                                <Layout fullWidth={false} title="Valuations">
                                    <ValuationsPage />
                                </Layout>
                            </Route>
                            <Route path="/changepassword">
                                <Layout fullWidth={false} title="Change Password">
                                    <ChangePasswordPage />
                                </Layout>
                            </Route>
                            <Route path="/admin/users">
                                <Layout fullWidth title="Admin - Users">
                                    <AdminUsersPage />
                                </Layout>
                            </Route>
                            <Route path="/admin/users/new">
                                <Layout fullWidth={false} title="Admin - New User">
                                    <AdminUserPage />
                                </Layout>
                            </Route>
                            <Route path="/admin/users/:id">
                                <Layout fullWidth={false} title="Admin - User">
                                    <AdminUserPage />
                                </Layout>
                            </Route>
                            <Route path="/admin/roles">
                                <Layout fullWidth title="Admin - Roles">
                                    <AdminRolesPage />
                                </Layout>
                            </Route>
                            <Route path="/admin/roles/new">
                                <Layout fullWidth={false} title="Admin - New Role">
                                    <AdminRolePage />
                                </Layout>
                            </Route>
                            <Route path="/admin/roles/:id">
                                <Layout fullWidth={false} title="Admin - Role">
                                    <AdminRolePage />
                                </Layout>
                            </Route>
                            <Route path="/admin/redis">
                                <Layout fullWidth={false} title="Admin - Redis">
                                    <AdminRedisPage />
                                </Layout>
                            </Route>
                            <Route path="/swaplab2">
                                <Layout fullWidth={false} title="Swaplab2">
                                    <SwapLab2Page />
                                </Layout>
                            </Route>
                            <Route path="/swaplab2/compare">
                                <Layout fullWidth title="Swaplab2 Compare">
                                    <ValuationComparePage />
                                </Layout>
                            </Route>
                            <Route path="/valuationmappings">
                                <Layout fullWidth title="Valuation Mappings">
                                    <ValuationMappingsPage />
                                </Layout>
                            </Route>
                            <Route path="/valuationmapping/:id">
                                <Layout fullWidth={false} title="Valuation Mapping">
                                    <ValuationMappingPage />
                                </Layout>
                            </Route>
                            <Route path="/performance">
                                <Layout fullWidth title="Performance">
                                    <PerformancePage />
                                </Layout>
                            </Route>
                            <Route path="/performance/:clientDashName">
                                <Layout fullWidth title="Performance" showClient>
                                    <PerformancePage />
                                </Layout>
                            </Route>
                            <Route path="/performance/:clientDashName/:tabId">
                                <Layout fullWidth title="Performance" showClient>
                                    <PerformancePage />
                                </Layout>
                            </Route>
                            <Route path="/accountperformance">
                                <Layout fullWidth title="Account Performance">
                                    <AccountPerformancePage />
                                </Layout>
                            </Route>
                            <Route path="/accountperformance/">
                                <Layout fullWidth title="Account Performance">
                                    <AccountPerformancePage />
                                </Layout>
                            </Route>
                            <Route path="/accountperformance/:clientDashName">
                                <Layout fullWidth title="Account Performance" showClient>
                                    <AccountPerformancePage />
                                </Layout>
                            </Route>
                            <Route path="/positions">
                                <Layout fullWidth title="Positions">
                                    <PositionsGroupedPage />
                                </Layout>
                            </Route>
                            <Route path="/positions/:clientDashName">
                                <Layout fullWidth title="Positions">
                                    <PositionsGroupedPage />
                                </Layout>
                            </Route>
                            <Route path="/swaptions">
                                <Layout fullWidth title="Swaptions">
                                    <SwaptionsPage />
                                </Layout>
                            </Route>
                            <Route path="/bonds">
                                <Layout fullWidth title="Bonds">
                                    <BondsPage />
                                </Layout>
                            </Route>
                            <Route path="/portfoliorisk">
                                <Layout fullWidth title="Portfolio Risk">
                                    <PortfolioRiskAndLimits />
                                </Layout>
                            </Route>
                            <Route path="/portfoliorisk/:clientDashName">
                                <Layout fullWidth title="Portfolio Risk" showClient>
                                    <PortfolioRiskAndLimits />
                                </Layout>
                            </Route>
                            <Route path="/portfoliorisk/:clientDashName/:tabId">
                                <Layout fullWidth title="Portfolio Risk" showClient>
                                    <PortfolioRiskAndLimits />
                                </Layout>
                            </Route>
                            <Route path="/compare">
                                <Layout fullWidth title="Compare">
                                    <ComparePage />
                                </Layout>
                            </Route>
                            <Route path="/compare2">
                                <Layout fullWidth title="Compare (legacy)">
                                    <ComparePage2 />
                                </Layout>
                            </Route>
                            <Route path="/movers">
                                <Layout fullWidth title="Movers">
                                    <MoversPage />
                                </Layout>
                            </Route>
                            <Route path="/operations">
                                <Layout fullWidth title="Operations">
                                    <OperationsTabPage />
                                </Layout>
                            </Route>
                            <Route path="/operations/:clientDashName">
                                <Layout fullWidth title="Operations" showClient>
                                    <OperationsTabPage />
                                </Layout>
                            </Route>
                            <Route path="/operations/:tabId">
                                <Layout fullWidth title="Operations">
                                    <OperationsTabPage />
                                </Layout>
                            </Route>
                            <Route path="/operations/:clientDashName/:tabId">
                                <Layout fullWidth title="Operations" showClient>
                                    <OperationsTabPage />
                                </Layout>
                            </Route>
                            <Route path="/operations/:clientDashName/:tabId/:transId">
                                <Layout fullWidth title="Operations" showClient>
                                    <OperationsTabPage />
                                </Layout>
                            </Route>
                            <Route path="/curvedefinitions">
                                <Layout fullWidth={false} title="Curve Definitions">
                                    <CurveDefinitionsPage />
                                </Layout>
                            </Route>
                            <Route path="/curvedefinitions/:id">
                                <Layout fullWidth={false} title="Curve Definitions">
                                    <CurveDefinitionPage />
                                </Layout>
                            </Route>
                            <Route path="/agreements">
                                <Layout fullWidth={false} title="Agreements">
                                    <AgreementsPage />
                                </Layout>
                            </Route>
                            <Route path="/agreements/:id">
                                <Layout fullWidth={false} title="Agreements">
                                    <AgreementPage />
                                </Layout>
                            </Route>
                            <Route path="/notes">
                                <Layout fullWidth={false} title="New Note">
                                    <NotesPage esgOnly={false} routeToNew={"/notes/new"} routeToNewText={"New note"} />
                                </Layout>
                            </Route>
                            <Route path="/notes/:id">
                                <Layout fullWidth={true} fullHeight={true} title="Notes">
                                    <NotePage routeToNotes={"/notes"} routeToNotesText={"All notes"}></NotePage>
                                </Layout>
                            </Route>
                            <Route path="/riskdocs">
                                <Layout fullWidth={false} title="Risk Documents">
                                    <DurationRiskDocPage />
                                </Layout>
                            </Route>
                            <Route path="/quotes">
                                <Layout fullWidth={false} title="Quotes">
                                    <QuotesPage />
                                </Layout>
                            </Route>
                            <Route path="/quotes/:id">
                                <Layout fullWidth={false} title="Quotes">
                                    <QuotePage />
                                </Layout>
                            </Route>
                            <Route path="/prices/:id">
                                <Layout fullWidth={true} fullHeight={true} title="Prices">
                                    <PricePage />
                                </Layout>
                            </Route>
                            <Route path="/prices">
                                <Layout fullWidth={false} title="Prices">
                                    <PricesPage />
                                </Layout>
                            </Route>
                            <Route path="/termsofservice">
                                <Layout fullWidth={false} title="Terms Of Service">
                                    <TermsOfServicePage />
                                </Layout>
                            </Route>
                            <Route path="/backoffice/customers/:id">
                                <Layout fullWidth={true} fullHeight={true} title="Customers">
                                    <CustomersPage />
                                </Layout>
                            </Route>
                            <Route path="/backoffice/customers">
                                <Layout fullWidth={true} title="Customers">
                                    <CustomersPage />
                                </Layout>
                            </Route>
                            <Route path="/monthlycosts">
                                <Layout fullWidth={true} title="Costs - Monthly">
                                    <MonthlyCostsPage />
                                </Layout>
                            </Route>
                            <Route path="/extensions">
                                <Layout fullWidth={true} title="Extensions">
                                    <ExtensionsPage />
                                </Layout>
                            </Route>
                            <Route path="/extensions/:id">
                                <Layout fullWidth={true} title="Extensions">
                                    <ExtensionPage />
                                </Layout>
                            </Route>
                            <Route path="/files/:fileId">
                                <DownloadFile />
                            </Route>
                            <Route>
                                <Layout fullWidth={false} title="No match">
                                    <NoMatch />
                                </Layout>
                            </Route>
                        </Switch>
                    </ProtectedLayout>
                </div>
            </OPItemContextProvider>
        </ContextProvider>
    );
};
